<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending"
                                   :title="item.name"/>
                <app-content-title v-if="newItem" :title="translations.newProvider"/>
            </div>
            <div :title="translations.information">
                <app-settings @submit="onFormSubmit" :disabled="pending">
                    <app-settings-content>
                        <app-settings-desc :title="translations.basicInfo">
                            <p>
                                <translate>Založeno</translate>
                                :<br/>
                                <span v-html="formatDateAdvanced(item._created)"/>
                            </p>
                        </app-settings-desc>

                        <app-settings-options>
                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.name"
                                    required
                                    :error="errors.items.find(el => el.field === 'name')"
                                    v-model="formItem.name"
                                    name="name"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-settings-control class="checkbox">
                                    <app-checkbox
                                        name="active"
                                        :title="translations.active"
                                        :error="!!errors.first('active')"
                                        v-model="formItem.active"
                                        @change="changeActive"
                                    />
                                </app-settings-control>
                            </app-settings-col>

                            <app-settings-col class="field_left">
                                <app-input
                                    :label="translations.metadataSourceUrl"
                                    :error="errors.items.find(el => el.field === 'metadataSourceUrl')"
                                    v-model="formItem.metadataSourceUrl"
                                    name="metadataSourceUrl"

                                />
                            </app-settings-col>
                            <app-settings-col class="field_right">
                                <app-input
                                        :label="translations.dataSourceUrl"
                                        :error="errors.items.find(el => el.field === 'dataSourceUrl')"
                                        v-model="formItem.dataSourceUrl"
                                        name="dataSourceUrl"

                                />
                            </app-settings-col>
                            <app-table-header-item class="field_right">
                                <app-table-header-select :label="translations.importer">
                                    <app-select
                                        id="importer"
                                        :options="importerOptions"
                                        selectId="importerSelect"
                                        name="importer"
                                        v-model="formItem.importer"
                                    />
                                </app-table-header-select>
                            </app-table-header-item>

                            <app-settings-input
                                :error="errors.items.find(el => el.field === 'note')"
                                :label="translations.note"
                            >
                                <app-textarea
                                    name="note"
                                    v-model="formItem.note"
                                />
                            </app-settings-input>

                            <app-settings-col class="field_left">
                                <app-image-input
                                    :label="translations.providerLogo"
                                    required
                                    :error="errors.items.find(el => el.field === 'logoImage')"
                                    v-model="formItem.logoImage"
                                    @fileChanged="onFileChange"
                                    :imageLink="logoImage.imageLink"
                                    name="imgLogo"
                                />
                            </app-settings-col>
                        </app-settings-options>
                    </app-settings-content>

                    <app-settings-buttons>
                        <app-content-save-button :disabled="pending" @click="disallowBack"/>
                    </app-settings-buttons>
                </app-settings>
            </div>
        </form>
    </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'
import {VUE_APP_BASE_API_URL} from "@/constants/fileConstants";
import axios from "axios";

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Provider',
  parentRouteName: 'vodProviders',
  storeModuleName: 'providers',
  storeItemName: 'provider'
})

export default {
  name: 'provider-item',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  data() {
    return {
      importers: {},
      active: false,
      logoImage: {
          changed: false,
          imageLink: null,
      }
    }
  },
    created() {
      this.fetchImporters();
    },
    methods: {
    fetchImporters() {
      axios.get(VUE_APP_BASE_API_URL + 'providers/importers').then(response => {
          this.importers = response.data;
      });
    },
    onFileChange() {
        this.logoImage.changed = true;
        this.logoImage.imageLink = null;
    },
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Provider')
      const response = await commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }

      const { elements } = e.target;
      const fileLogo = elements.namedItem('imgLogo').files[0];

      this.uploadImage(response.data.data._id, fileLogo);
    },
    async uploadImage(providerId, fileLogo) {
        const providerLogoApiUrl = VUE_APP_BASE_API_URL + 'providers/logo/' + providerId;

        try {
            if (this.logoImage.changed) {
                const formData = new FormData();

                if (fileLogo) {
                    formData.append('logo', fileLogo);

                    const uploadResult = await axios.post(providerLogoApiUrl, formData);
                } else {
                    await axios.delete(providerLogoApiUrl).then(response => {
                        this.logoImage.imageLink = null;
                    })
                }

            }
        } finally {
            this.logoImage.changed = false;
        }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    },
    changeActive(value) {
        this.active = value;
    }
  },
  computed: {
    translations() {
      return {
        newProvider: this.$gettext('Nový poskytovatel'),
        name: this.$gettext('Název'),
        basicInfo: this.$gettext('Zákldní údaje'),
        providerLogo: this.$gettext('Logo'),
        list: this.$gettext('Seznam'),
        information: this.$gettext('Informace'),
        metadataSourceUrl: this.$gettext('Zdroj metadat (URI)'),
        dataSourceUrl: this.$gettext('Zdroj dat (URI)'),
        active: this.$gettext('Aktivní'),
        note: this.$gettext('Poznámka')
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Poskytovatelé'), link: { name: 'vodProviders' } },
          this.item.name || this.translations.newProvider
      ]
    },
    importerOptions() {
      return Object.keys(this.importers).map(importer => {
        return { name: this.importers[importer], value: importer };
      });
    },
  },
  watch: {
    formItem() {
        this.active = this.formItem.active;

        if (this.formItem.logo) {
            this.logoImage.imageLink = this.formItem._imageRoot + '/provider_logos/' + this.formItem.logo;
        }
    }
  }
}
</script>
